var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareIconFigma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 5C18 6.65685 16.6569 8 15 8C14.0585 8 13.2183 7.56628 12.6683 6.88775L7.84194 9.03657C7.94443 9.33897 8 9.66301 8 10C8 10.2239 7.97549 10.442 7.929 10.6518L12.9696 12.7914C13.5039 12.3 14.2169 12 15 12C16.6569 12 18 13.3431 18 15C18 16.6568 16.6569 18 15 18C13.3432 18 12 16.6568 12 15C12 14.7112 12.0408 14.4319 12.117 14.1677L7.17253 12.0689C6.6261 12.6425 5.8548 13 5 13C3.34315 13 2 11.6569 2 10C2 8.34318 3.34315 7.00004 5 7.00004C5.73064 7.00004 6.40028 7.26123 6.92063 7.69534L12.0293 5.42082C12.01 5.28332 12 5.14283 12 5C12 3.34315 13.3432 2 15 2C16.6569 2 18 3.34315 18 5Z",
    fill: "#0044C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIconFigma);
export default __webpack_public_path__ + "static/media/share-icon-figma.27e1e454f30b3eb3bff539de2d4abdc7.svg";
export { ForwardRef as ReactComponent };